import { InWorkContainer, Text } from "./styledComponents";

const InWork = () => (
  <InWorkContainer>
    <Text>Раздел находится в разработке</Text>
  </InWorkContainer>
);

export default InWork;
